import { API_BASE, api } from "@/lib/apiClient";

export type SchwarzesBrettPreview = "pdf" | "convert" | "image" | "none";

export interface SchwarzesBrettFile {
  id: string;
  name: string;
  extension: string;
  size: number | null;
  web_url: string;
  last_modified_at: string | null;
  created_at: string | null;
  last_modified_by: string | null;
  folder_id: string | null;
  folder_name: string | null;
  /** Relativer Pfad tieferer Unterordner innerhalb des Ordners (leer = direkt im Ordner). */
  sub_path: string;
  preview: SchwarzesBrettPreview;
}

export interface SchwarzesBrettFolder {
  id: string;
  name: string;
  web_url: string;
  files: SchwarzesBrettFile[];
  file_count: number;
  latest_modified_at: string | null;
}

export interface SchwarzesBrettTree {
  root: { id: string; name: string; web_url: string } | null;
  root_path: string | null;
  folders: SchwarzesBrettFolder[];
  loose_files: SchwarzesBrettFile[];
  file_count: number;
  truncated: boolean;
  recent: SchwarzesBrettFile[];
  new_days: number;
  generated_at: string | null;
  cache_ttl_seconds: number;
}

export function fetchSchwarzesBrettTree(refresh = false): Promise<SchwarzesBrettTree> {
  const qs = refresh ? "?refresh=1" : "";
  return api.get<SchwarzesBrettTree>(`/schwarzes-brett/tree${qs}`, { timeoutMs: 60_000 });
}

export function schwarzesBrettFileUrl(
  fileId: string,
  opts: { format?: "original" | "pdf"; download?: boolean } = {},
): string {
  const params = new URLSearchParams();
  if (opts.format && opts.format !== "original") params.set("format", opts.format);
  if (opts.download) params.set("download", "1");
  const qs = params.toString();
  return `${API_BASE}/schwarzes-brett/files/${encodeURIComponent(fileId)}/content${qs ? `?${qs}` : ""}`;
}

export async function fetchSchwarzesBrettFileBlob(
  fileId: string,
  format: "original" | "pdf",
  signal?: AbortSignal,
): Promise<Blob> {
  const res = await fetch(schwarzesBrettFileUrl(fileId, { format }), {
    credentials: "include",
    signal,
  });
  if (!res.ok) {
    let message = `${res.status} ${res.statusText}`;
    try {
      const body = (await res.json()) as { detail?: unknown };
      if (typeof body?.detail === "string" && body.detail.trim()) message = body.detail;
    } catch {
      /* Body ist kein JSON */
    }
    throw new Error(message);
  }
  return res.blob();
}
